import React from 'react';

import { Link } from "gatsby"

import { makeStyles } from '@material-ui/styles';
import Paper          from '@material-ui/core/Paper';
import Typography     from '@material-ui/core/Typography';

import Img            from "gatsby-image"

import Comment from "src/components/post/Comment"
import Bio from "src/components/Bio"

const useStyles = makeStyles(theme => ({
  paperWrap: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)'
  },
  paperInner: {
    flex: '1 1 100%',
    margin: '0',
    maxWidth: '100%',
    [`@media (min-width: ${theme.mediaQueryTresholds.M}px)`]: {
      maxWidth: 'calc(100%)',
    },
    [`@media (min-width: ${theme.mediaQueryTresholds.L}px)`]: {
      maxWidth: 'calc(100%)',
    }
  },
  subTitleArea: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
  },
  meta: {
    ...theme.flex.row,
    ...theme.flex.alignCenter,
    margin: '0',
  },
  subTitle: {
    fontSize: '16px',
    marginTop: '0.5em',
  },
  tag: {
    fontSize: '16px',
    color: '#9468b9',
    marginTop: '0.5em',
  },
}));


export default function PostPage(props) {

  const { post, pageContext } = props
  const { previous, next } = pageContext
  const classes = useStyles()

  let featuredImage = post.frontmatter.featuredImage;
  let childImageSharp;
  let imgFluid;

  if (featuredImage !== undefined) {
    childImageSharp = featuredImage.childImageSharp || {};
    imgFluid = childImageSharp.fluid || {};
  }

  return (
    <Paper className={classes.paperWrap} elevation={1}>
      <div className={classes.paperInner}>
        <Typography variant="h4" component="h4">
          {post.frontmatter.title}
        </Typography>
        <div className={classes.subTitleArea}>
          <div>
            <Typography className={classes.subTitle} color="textSecondary">
              {post.frontmatter.subTitle}
            </Typography>
            <div className={classes.tag}>
              {post.frontmatter.tags && post.frontmatter.tags.join(', ')}
            </div>
          </div>
          <div className={classes.meta}>
            <Bio />
            <p style={{padding: '0 6px', margin:'0', opacity: `0.5`}}>
              in
            </p>
            <p
              style={{display: `block`, margin:'0'}}>
              {post.frontmatter.date}
            </p>
          </div>
        </div>
        <hr/>
        { imgFluid &&
          <Img fluid={imgFluid} />
        }
        <div 
          className="page-content"
          style={{padding: `10px 0 30px 0`}} 
          dangerouslySetInnerHTML={{ __html: post.html }} 
        />
        <hr style={{}}/>
        <ul
          style={{
            display: `flex`,
            flexWrap: `wrap`,
            justifyContent: `space-between`,
            listStyle: `none`,
            padding: 0,
          }}
        >
          <li>
            {previous && (
              <Link to={previous.fields.slug} rel="prev">
                ← {previous.frontmatter.title}
              </Link>
            )}
          </li>
          <li>
            {next && (
              <Link to={next.fields.slug} rel="next">
                {next.frontmatter.title} →
              </Link>
            )}
          </li>
        </ul>
        <Comment></Comment>
      </div>
    </Paper>
  );
}
